import React from "react";

export function TooltipAgendamento(props) {
    if (!(props.item.agendamentos || []).length) return null;

    return (
        <div
            style={{
                backgroundColor: "#f1cf1a",
                color: "#111",
                padding: "10px 8px",
                borderRadius: "0.3rem",
                fontSize: "0.7rem",
                display: "flex",
                justifyContent: "center",
                textWrap: "nowrap",
                minWidth: "fit-content",
                flexGrow: 1,
                margin: props.mobile ? "3px 0px -5px" : 3,
            }}
            title={`Agendamento de Alteração de Demanda:\n${props.item.agendamentos.map((agendamentoDemanda) => agendamentoDemanda.mensagem_tooltip)}`}
        >
            <b>AGENDAMENTO</b>
        </div>
    );
}
